import Extendable from './Extendable'

const OfficeHourable = {
  officeHourSubscriptions: (officeHourSubscriptions, subscription) => {
    return officeHourSubscriptions.filter((officeHourSubscription) => {
      const sku1 = subscription.sku && subscription.sku.toUpperCase().replace(/_SUB_FULL/i, '').replace(/_OH/i, '')
      const sku2 = officeHourSubscription.sku && officeHourSubscription.sku.toUpperCase().replace(/_SUB_FULL/i, '').replace(/_OH/i, '')
      const sameSku = sku1 == sku2
      const sameAssignedTo = officeHourSubscription.isEnrolled && officeHourSubscription.assignedToEmail == subscription.assignedToEmail
      return sameSku && sameAssignedTo
    })
  },
  unassigned: (officeHourSubscriptions, subscriptions, lineItemsExtension) => {
    return officeHourSubscriptions.filter((officeHourSubscription) => {
      const isEnrolled = officeHourSubscription.isEnrolled
      const needsPayment = officeHourSubscription.needsPayment
      const related = OfficeHourable.officeHourSubscriptions(subscriptions, officeHourSubscription).filter((subscription) => {
        // shopper#785 : remove previous related subscriptions
        return !Extendable.isPrevious(lineItemsExtension, subscription)
      })
      const isActive = !!officeHourSubscription.isActive
      return (!isEnrolled || !related.length) && !!isActive
    })
  },
  flags: (officeHourSubscriptions, subscription, officeHours, shop_name) => {
    const results = []
    if (subscription.enrollment) {
      if (!subscription.enrollment.isActive) {
        results.push("is_not_active")
      }
      if (!subscription.enrollment.isAssigned) {
        results.push("is_not_assigned")
      }
      if (subscription.enrollment.isTemp) {
        results.push("is_temp_enroll")
      }
      if (subscription.enrollment.isFreeTrial) {
        results.push("is_free_trial")
      }
      if (!subscription.enrollment.isRoleStudent) {
        results.push(`role_${subscription.enrollment.role}`)
      }
    }
    if (subscription.lineItem && subscription.lineItem.isTemp) {
      results.push("is_temp")
    }
    if (subscription.isInstructorCourse) {
      results.push('is_instructor_course')
    }
    if (!subscription.isEnrolled) {
      results.push('no_enrollment')
    }
    // shopper#900 : only if not observed_by
    if (!!subscription.observedBy) {
      results.push('observed_by')
    }
    const officeHour = officeHours && officeHours.find((officeHour) => officeHour.relatesTo(subscription.sku))
    if (!officeHour) {
      results.push('no_related_office_hour')
    }
    if (officeHour && !officeHour.product) {
      results.push('no_office_hour_product')
    }
    if (officeHour && officeHour.product && officeHour.product.status != 'active') {
      results.push('office_hour_product_not_active')
    }
    if (officeHour && officeHour.belongsToOtherShop(shop_name)) {
      results.push('office_hour_from_other_shop')
    }
    if (OfficeHourable.officeHourSubscriptions(officeHourSubscriptions, subscription).length) {
      results.push('office_hour_already_assigned')
    }
    return results
  }
}

export default OfficeHourable
